import { useState } from "react";
import { useParams } from "react-router-dom";
import Header from "../general/Header";
import { Box, styled, Typography } from "@mui/material";
import PhotoAdjustments from "./PhotoAdjustments";
import MorePrints from "./MorePrints";
import { useShopifyCollectionsControllerGetCollectionsWithProducts } from "../../services/generated";
import CheckoutButtons from "./CheckoutButtons";

const Wrapper = styled(Box)({
  width: "100%",
  overflowX: "hidden",
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
});

const Content = styled(Box)({
  marginTop: "clamp(1rem, 3vw, 2rem)",
});

const CollectionTitle = styled(Typography)({
  color: "#AEAEAE",
  padding: "clamp(0.5rem, 1vw, 1rem)",
  fontSize: "clamp(0.7rem, 2vw, 1.1rem)",
  fontFamily: "Gantari, sans-serif",
});

const ProductTitle = styled(Typography)({
  fontFamily: "Geist, sans-serif",
  color: "black",
  marginTop: "clamp(0.5rem, 1vw, 1rem)",
  fontSize: "clamp(0.7rem, 2vw, 1.3rem)"
});

const SingleItemDetails = () => {
  const [selectedVariant, setSelectedVariant] = useState(0);
  const { collectionId, productId } = useParams();
  const { data } = useShopifyCollectionsControllerGetCollectionsWithProducts();

  const collections = data?.data;
  const selectedCollection = collections?.find(
    (collection) => Number(collection.id) === Number(collectionId),
  );

  const selectedProduct = selectedCollection?.products.find(
    (prodcut) => Number(prodcut.id) === Number(productId),
  );
  return (
    <Wrapper>
      <Header />
      <Content>
        <CollectionTitle variant="h6">
          {selectedCollection?.title}
        </CollectionTitle>

        <Box
          sx={{
            width: "30vw",
            backgroundColor: "#F3F3F3",
            padding: 5,
          }}
        >
          <Box
            component="img"
            src={selectedProduct?.variants[selectedVariant].image}
            sx={{
              width: "100%",
              height: "auto",
              display: "block",
            }}
          />
        </Box>
        <ProductTitle variant="h6">{selectedProduct?.title}</ProductTitle>
        <PhotoAdjustments
          selectedProduct={selectedProduct}
          setSelectedVariant={setSelectedVariant}
        />
      </Content>
      {selectedCollection && (
        <CheckoutButtons
          selectedProduct={selectedProduct}
          selectedVariant={selectedVariant}
          collectionTitle={selectedCollection.title}
        />
      )}
      <MorePrints
        selectedCollection={selectedCollection}
        selectedProductId={productId}
      />
    </Wrapper>
  );
};

export default SingleItemDetails;
